module.exports = "/_next/static/images/96a400dfd2138c72f3be827fa7ca92a6-wellDone.svg.webp";